import React, { useState } from "react";
import Page from "../../components/Page";
import {
  Card,
  Container,
  Dialog,
  DialogContent,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import CatalogoEgresosTable from "../../sections/@catalogos/catalogoegresos/CatalogoEgresos";
import MuiAlert from "@mui/material/Alert";
import AddCatalogoEgresosButtom from "../../sections/@catalogos/catalogoegresos/AddCatalogoEgresosButtom";
const ConceptoEgresos = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [errorGraph, setErrorGraph] = useState({
    severity: "",
    mensaje: "",
  });
  const [bodyDialog, setBodyDialog] = useState("");
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };
  return (
    <>
      <Page title="Conceptos Egresos">
        <Container maxWidth="xl">
        <AddCatalogoEgresosButtom
            setOpenDialog={setOpenDialog}
            setBodyDialog={setBodyDialog}
            setErrorGraph={setErrorGraph}
            setOpenSnackBar={setOpenSnackBar}
          />
          <Card>
            <CatalogoEgresosTable
              setOpenDialog={setOpenDialog}
              setBodyDialog={setBodyDialog}
              setErrorGraph={setErrorGraph}
              setOpenSnackBar={setOpenSnackBar}
            />
          </Card>
        </Container>
        <Dialog open={openDialog}>
          <DialogContent>{bodyDialog}</DialogContent>
        </Dialog>
        <Snackbar
          open={openSnackBar}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={errorGraph.severity}
            sx={{ width: "100%" }}
          >
            {errorGraph.mensaje}
          </Alert>
        </Snackbar>
      </Page>
    </>
  );
};

export default ConceptoEgresos;
